import styled from 'styled-components';
import PageTitle from './PageTitle';

export default styled(PageTitle)`
  margin-bottom: 2rem;
`;
